import React, { useEffect, useState } from "react";
import {
  Card, Table, Typography, Space, Tabs, Button, Tag,
  message, Badge, Alert,
} from "antd";
import { UserOutlined, GlobalOutlined, DatabaseOutlined } from "@ant-design/icons";
import { adminApi } from "../api/client";

const { Title, Text } = Typography;

const ROL_COLORS: Record<string, string> = {
  Administrador: "red", Manager: "orange", "Domain Lead": "blue",
  "IABP Owner": "purple", "Tech Lead": "geekblue", Colaborador: "default", "Solo lectura": "default",
};

const DOMINIO_MANDATOS: Record<string, string> = {
  D1: "Ideación y Cualificación",
  D2: "Portfolio Local Core Suite",
  D3: "Delivery IA BPO/CCaaS FAB",
  D4: "IA Adopción y Aceleración",
  D5: "LOWI Core LATAM",
  "Hub IA": "Hub de Habilitación IA",
};

export default function AdminPage() {
  const [usuarios, setUsuarios] = useState<any[]>([]);
  const [dominios, setDominios] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [seedLoading, setSeedLoading] = useState(false);

  const cargar = async () => {
    setLoading(true);
    try {
      const [u, d] = await Promise.all([adminApi.usuarios(), adminApi.dominios()]);
      setUsuarios(u.data);
      setDominios(d.data);
    } catch { message.error("Error cargando datos"); }
    finally { setLoading(false); }
  };

  useEffect(() => { cargar(); }, []);

  const handleSeedDominios = async () => {
    setSeedLoading(true);
    try {
      const res = await adminApi.seedDominios();
      message.success(`Dominios inicializados: ${res.data.creados.join(", ") || "Ya existían todos"}`);
      cargar();
    } catch { message.error("Error inicializando dominios"); }
    finally { setSeedLoading(false); }
  };

  const userColumns = [
    { title: "Nombre", dataIndex: "nombre", render: (v: string, r: any) => `${v} ${r.apellidos ?? ""}`.trim() },
    { title: "Email", dataIndex: "email", ellipsis: true },
    { title: "Rol", dataIndex: ["rol", "nombre"], render: (v: string) => <Tag color={ROL_COLORS[v] ?? "default"}>{v}</Tag> },
    {
      title: "Estado", dataIndex: "activo",
      render: (v: boolean) => <Badge status={v ? "success" : "error"} text={v ? "Activo" : "Inactivo"} />,
    },
  ];

  const dominioColumns = [
    { title: "Código", dataIndex: "codigo", width: 80, render: (v: string) => <Tag color="#1a1f5e" style={{ color: "#fff" }}>{v}</Tag> },
    { title: "Nombre", dataIndex: "nombre" },
    { title: "Mandato", dataIndex: "mandato", ellipsis: true },
    { title: "Estado", dataIndex: "activo", width: 90, render: (v: boolean) => <Badge status={v ? "success" : "default"} text={v ? "Activo" : "Inactivo"} /> },
  ];

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <Title level={4} style={{ margin: 0, color: "#1a1f5e" }}>Administración</Title>
        <Text type="secondary" style={{ fontSize: 13 }}>Gestión de usuarios, dominios y configuración</Text>
      </div>

      <Card size="small">
        <Tabs
          items={[
            {
              key: "usuarios",
              label: <Space><UserOutlined />Usuarios ({usuarios.length})</Space>,
              children: (
                <Table
                  dataSource={usuarios} columns={userColumns}
                  rowKey="id" loading={loading} size="small"
                  pagination={{ pageSize: 20 }}
                />
              ),
            },
            {
              key: "dominios",
              label: <Space><GlobalOutlined />Dominios ({dominios.length})</Space>,
              children: (
                <div>
                  {dominios.length === 0 && (
                    <Alert
                      type="warning" showIcon
                      message="No hay dominios configurados"
                      description="Inicializa los 5 dominios + Hub IA del equipo con el botón de abajo."
                      action={
                        <Button size="small" loading={seedLoading}
                          onClick={handleSeedDominios} style={{ background: "#1a1f5e", color: "#fff", border: "none" }}>
                          Inicializar dominios
                        </Button>
                      }
                      style={{ marginBottom: 16 }}
                    />
                  )}
                  {dominios.length > 0 && (
                    <Space style={{ marginBottom: 12 }}>
                      <Button size="small" icon={<DatabaseOutlined />}
                        loading={seedLoading} onClick={handleSeedDominios}>
                        Sincronizar dominios
                      </Button>
                    </Space>
                  )}
                  <Table
                    dataSource={dominios} columns={dominioColumns}
                    rowKey="id" loading={loading} size="small"
                    pagination={false}
                  />
                </div>
              ),
            },
          ]}
        />
      </Card>
    </div>
  );
}
